/**
 * Resolution could not settle this occurrence. The header tag pipeline carries a label and colours
 * only — no tooltip channel — so the reason rides in the label rather than being dropped; the full
 * text also stays on the Manage summary's `reviewReason` field.
 */
import { VisitBrowseRow } from '@jms/model';
import { defineConditionalTag } from '../../shared/define.conditional.tag';

export const visitNeedsReviewTag = defineConditionalTag<VisitBrowseRow>(row => {

  if (!row.needsReview) return null;
  const reason = row.reviewReason?.trim();
  return { label: reason ? `Needs review: ${reason}` : 'Needs review', tone: 'warning' };
});
